export enum FirebaseStorageBucketFolder {
    SubmissionsImages = 'submissions-images',
    TmpSubmissionsImages = 'tmp-submissions-images',
    ArtisanProfileImages = 'artisan-profile-images',
    ArtisanProfileLogos = 'artisan-profile-logos',
    ArtisanProjectsImages = 'artisan-projects-images',
    RequestEstimateAttachments = 'request-estimate-attachments',
    RequestQuoteAttachments = 'request-quote-attachments',
}

export enum FirebasePageMode {
    ResetPassword = 'resetPassword',
}
